import React, { useState, useEffect, useRef } from 'react'
import { IonButton, IonButtons, IonChip, IonContent, IonDatetime, IonFooter, IonGrid, IonHeader, IonIcon, IonItemDivider, IonModal, IonRow, IonText, IonTitle, IonToolbar, isPlatform } from '@ionic/react'
import dayjs from 'dayjs';
import CreateCalendarPickerTimeline from './CreateCalendarPickerTimeline';
import { arrowForward, close } from 'ionicons/icons';
import Api from '../../services/Api';

interface ErrorInterface  {
  status: boolean,
  message: string
  title: boolean,
  map: boolean,
  start: boolean,
  type: boolean
}

interface ComponentProps {
  error?: ErrorInterface
  length_minutes: number,
  start: string,
  handleStart: Function
  handleLength: Function
  setError: React.Dispatch<React.SetStateAction<ErrorInterface>>
  activeSlide: boolean
  slideNext: Function
  slidePrevious: Function
  cancelCreate: Function
}

const CreateCalendarPicker = ({ length_minutes, start, activeSlide, handleStart, handleLength, slideNext, cancelCreate } : ComponentProps) => {
  const api = Api.getInstance()
  const [time, setTime] = useState<string | null | undefined>()
  const [endtime, setEndtime] = useState<string | null | undefined>()
  const [openPopover, setOpenPopover] = useState(false)
  const [state, setState] = useState({
    timeset: false,
    startset: false,
    endset: false,
    minutes: 60
  })
  const [pickertype, setPickertype] = useState('date-time')
  const [startEnd, SetStartEnd] = useState('start')
  const [openSync, setOpenSync] = useState(false)
  const datetime = useRef<null | HTMLIonDatetimeElement>(null)
  const datetimeStart = useRef<null | HTMLIonDatetimeElement>(null);
  const datetimeEnd = useRef<null | HTMLIonDatetimeElement>(null);

  useEffect(() => {
    // console.log(start, time, length_minutes);
    if(start) {
      setState({
        ...state,
        timeset: true,
        startset: true,
      })
      setTime(dayjs(start).format('YYYY-MM-DD HH:mm'))
      setEndtime(dayjs(start).add(length_minutes, 'minutes').format('YYYY-MM-DD HH:mm'))
    }
  }, [])

  useEffect(() => {
    walkLength(time, endtime)
    checkIfSameDay()
  }, [endtime, time])

  useEffect(() => {
    handleLength(state.minutes)
  }, [state.minutes])

  const walkLength = (start: any, end: any) => {
    setState({
      ...state,
      minutes: dayjs(end).diff(dayjs(start),'minutes')
    })
  }

  const confirm = () => {
    datetime.current?.confirm()
    if(startEnd === 'start') {
      if(datetime.current && datetime.current.value) {
        handleStart(dayjs(datetime.current?.value as string).format('YYYY-MM-DD HH:mm'))
        setTime(dayjs(datetime.current?.value as string).format('YYYY-MM-DD HH:mm'))  
      }

      if(!state.endset) {
        setEndtime(dayjs(getSameDay(true)).add(1, 'hour').format('YYYY-MM-DD HH:mm'))
      } else {
        setEndtime(dayjs(getSameDay()).format('YYYY-MM-DD HH:mm'))
      }
    } 

    setOpenPopover(false)
  }

  const confirmStart = () => {
    if(datetimeStart.current && datetimeStart.current.value) {
      const hour = parseInt(dayjs(datetimeStart.current?.value as string).format('HH'))
      const minutes = parseInt(dayjs(datetimeStart.current?.value as string).format('mm'))
      const newTime = dayjs(time).set('hour', hour).set('minutes', minutes).format('YYYY-MM-DD HH:mm')
   
      handleStart(newTime)
      setTime(newTime)  
    }

    setOpenPopover(false)
  }

  const confirmEnd = () => {
    if(datetimeEnd.current && datetimeEnd.current.value) {
      const hour = parseInt(dayjs(datetimeEnd.current?.value as string).format('HH'))
      const minutes = parseInt(dayjs(datetimeEnd.current?.value as string).format('mm'))
      const newTime = dayjs(time).set('hour', hour).set('minutes', minutes).format('YYYY-MM-DD HH:mm')
   
      setEndtime(newTime)  
    }
    
    setOpenPopover(false)
  }

  const checkIfSameDay = () => {
    const start = dayjs(time).date()
    const end = dayjs(endtime).date()

    if(start !== end) {
      setEndtime(dayjs(getSameDay()).format('YYYY-MM-DD HH:mm'))
    }
  }

  const getSameDay = (newTime?: any) => {
    const hourRegex = /[0-9][0-9](?=:)/g
    const minutesRegex = /\d{2}$/g
    let timeH = endtime?.match(hourRegex)
    let timeM = endtime?.match(minutesRegex)

    if(newTime && datetime.current && datetime.current.value !== null && datetime.current.value !== undefined) {
      const datetimeValue = datetime.current.value as string

      timeH = datetimeValue.match(hourRegex)
      timeM = datetimeValue.match(minutesRegex)
    } else {
      timeH = endtime?.match(hourRegex)
      timeM = endtime?.match(minutesRegex)
    }

    if(timeH && timeM) {
      const sameDayEnd = dayjs(time).set('hour', parseInt(timeH[0])).set('minute', parseInt(timeM[0]))
      return sameDayEnd
    } else {
    }
  }

  const isoHelper = (obj: any) => {
    const date = new Date(obj); // Or the date you'd like converted.
    const isoDateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString()

    return isoDateTime
  }

  const setTimeValue = () => {
    if(startEnd === 'start') {
      if(start) {
        return isoHelper(start)
      } else {
        return dayjs().toISOString()
      }
    } else {
      return isoHelper(endtime)
    }
  }

  useEffect(() => {
    if(time === undefined && activeSlide && !start) {
      setOpenPopover(true)
    }
  })

  const timeConvert = (minutes: number) => {
    const num = minutes;
    const hours = (num / 60);
    const rhours = Math.floor(hours);
    const min = (hours - rhours) * 60;
    const rminutes = Math.round(min);
    return rhours + "h " + rminutes + " min";
  }

  const setTimePicker = (hour: number) => {
    handleStart(dayjs(time).set('hour', hour).set('minutes', 0).format('YYYY-MM-DD HH:mm'))
    setTime(dayjs(time).set('hour', hour).set('minutes', 0).format('YYYY-MM-DD HH:mm'))
    setEndtime(dayjs(time).set('hour', hour).set('minutes', 0).add(1, 'hour').format('YYYY-MM-DD HH:mm'))
  }

  const closeCalendarSync = () => {
    setOpenSync(false)
  }
    
  return (
    <IonGrid>
      <IonRow>
        <IonItemDivider class="p-2" color='darkblue' onClick={() => {
          setPickertype('date-time')
          setOpenPopover(true)
          SetStartEnd('start')
          }}>
          <IonChip color="light" slot="start" className="circle_small flex justify-center items-center mx-2">1</IonChip>
          Välj dag
        </IonItemDivider>
        <IonItemDivider class="p-2" color="light" onClick={() => {
          setPickertype('date-time')
          setOpenPopover(true)
          SetStartEnd('start')
          }}>
          {dayjs(time).format('dddd DD, YYYY')}
        </IonItemDivider>
        <IonItemDivider class="p-2" color={time === undefined ? 'medium' : 'darkblue'} onClick={() => {
          setPickertype('date-time')
          setOpenPopover(true)
          SetStartEnd('start')
          }}>
          <IonChip color="light" slot="start" className="circle_small flex justify-center items-center mx-2">2</IonChip>
          Välj tid
        </IonItemDivider>
        <IonItemDivider class="p-2" color="light" onClick={() => {
          setOpenPopover(true)
          setPickertype('time')
          SetStartEnd('start')
          }}>
          Start: {dayjs(time).format('HH:mm')}
        </IonItemDivider>
        <IonItemDivider class="p-2" color="light" onClick={() => {
          setOpenPopover(true)
          setPickertype('time')
          SetStartEnd('end')
          }}>
          Slut: {dayjs(endtime).format('HH:mm')}
          <IonChip className="p-2" slot="end" color="light">
            { timeConvert(state.minutes) }
          </IonChip>
        </IonItemDivider>
        { isPlatform('capacitor') ? 
        <IonItemDivider color="medium" class="p-2" onClick={() => setOpenSync(true)}>
          Synkronisera kalender
        </IonItemDivider> 
        : null } 
      </IonRow>

      <CreateCalendarPickerTimeline 
        openSync={openSync}
        closeSync={closeCalendarSync}
        setTimePicker={setTimePicker}
        day={start}
        end={endtime}/>
      <IonModal 
        className="modal_full"
        isOpen={openPopover}
        onDidDismiss={() => setOpenPopover(false)}>
          <IonHeader>
            <IonToolbar color="darkblue">
            {pickertype === 'date-time' ? 
              <IonChip color="light" slot="start" className="circle_small flex justify-center items-center mx-2">1</IonChip>
              : 
              <IonChip color="light" slot="start" className="circle_small flex justify-center items-center mx-2">2</IonChip>
            }
              <IonTitle className="p-2">
                { pickertype === 'date-time' ? 'Välj dag' : 'Välj tid' }
              </IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setOpenPopover(false)}>
                  <IonIcon icon={close}/>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent >
          { time === undefined ? 
            <IonRow className="p-2 color_blue flex justify-center items-center"><h2 className=" my-2">Du måste välja ett datum för att gå vidare</h2></IonRow>
          : null}
            <IonRow class="justify-center my-4">
            { pickertype === 'date-time' ?  
              <IonDatetime 
                mode="ios"
                color="teal"
                ref={datetime}
                multiple={false}
                firstDayOfWeek={1}
                presentation={pickertype === 'date-time' ? 'date' : 'time'}/> 
                : null }
              { pickertype === 'date-time' ?  null : 
                <>
                { startEnd === 'start' ? 
                  <IonDatetime 
                    mode="ios"
                    color="teal"
                    ref={datetimeStart}
                    firstDayOfWeek={1}
                    presentation='time'
                    value={new Date(time as string).toLocaleDateString()}/>
                  :
                  <IonDatetime 
                    mode="ios"
                    color="teal"
                    ref={datetimeEnd}
                    firstDayOfWeek={1}
                    presentation='time'
                    value={new Date(endtime as string).toLocaleDateString()}/>
                  }
                </>
              }
            </IonRow>
            <IonRow className="my-4">
              <IonButton 
                class="fullWidth m-2" 
                onClick={() => {
                  if(pickertype === 'date-time') {
                    confirm()
                  } else {
                    if(startEnd === 'start') {
                      confirmStart()
                    } else {
                      confirmEnd()
                    }
                  }
              }}>
              { pickertype === 'date-time' ? 'Välj dag' : 'Välj tid' }
              </IonButton>
            </IonRow>
          </IonContent>
      </IonModal>
      <IonFooter style={{'position': 'absolute', 'bottom': 0}}>
        <IonToolbar color="light" className="p-4 text_center">
          <IonText className="color_blue">Promenaden startar <b>{dayjs(start).locale(api.lang).format('dddd DD MMMM HH:mm')}</b></IonText>
          <IonButton 
            className="m-4"
            expand="block" 
            onClick={() => slideNext()}>
              Välj och gå vidare
              <IonIcon icon={arrowForward} />
          </IonButton>
          <IonButton 
            onClick={() => {
              cancelCreate()
            }}
            expand="block" 
            fill="clear"
            className="m-2 fullWidth">
            Avbryt
          </IonButton>
        </IonToolbar>
      </IonFooter>
    </IonGrid>
  )
}

export default CreateCalendarPicker
